import {
  gadgetThemeClass
} from "./chunk-XXDZHRIA.mjs";

// src/components/Pages/arShared/ScannerFrame.tsx
import React from "react";
var classes = (...parts) => parts.filter(Boolean).join(" ");
var SPARKLES = [
  [14, 20],
  [84, 16],
  [22, 80],
  [78, 74]
];
function ScannerFrame({
  spec,
  locked,
  status,
  showStatus = true,
  hint,
  progress,
  readout,
  className,
  ariaHidden,
  before,
  children,
  after
}) {
  const isTech = spec.value === "scifi" || spec.value === "spy";
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classes(
        "vm-scanner",
        className,
        gadgetThemeClass(spec),
        locked && "vm-locked"
      ),
      role: "region",
      "aria-label": spec.ariaLabel,
      "aria-hidden": ariaHidden
    },
    before,
    /* @__PURE__ */ React.createElement("div", { className: "vm-layer vm-tint", "aria-hidden": "true" }),
    spec.value === "scifi" && /* @__PURE__ */ React.createElement("div", { className: "vm-layer vm-scanlines", "aria-hidden": "true" }),
    spec.value === "spy" && /* @__PURE__ */ React.createElement("div", { className: "vm-layer vm-grid", "aria-hidden": "true" }),
    /* @__PURE__ */ React.createElement("div", { className: "vm-layer vm-reticle-wrap", "aria-hidden": "true" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classes(
          "vm-reticle",
          spec.value === "spy" && "vm-crosshair"
        )
      },
      /* @__PURE__ */ React.createElement("span", { className: "vm-corner vm-corner-tl" }),
      /* @__PURE__ */ React.createElement("span", { className: "vm-corner vm-corner-tr" }),
      /* @__PURE__ */ React.createElement("span", { className: "vm-corner vm-corner-bl" }),
      /* @__PURE__ */ React.createElement("span", { className: "vm-corner vm-corner-br" }),
      spec.value === "spy" && /* @__PURE__ */ React.createElement("span", { className: "vm-crosshair-dot" }),
      spec.value === "enchanted" && /* @__PURE__ */ React.createElement("span", { className: "vm-ring" }),
      spec.value === "spy" ? /* @__PURE__ */ React.createElement("span", { className: "vm-laser" }) : /* @__PURE__ */ React.createElement("span", { className: "vm-sweep" })
    )),
    spec.value === "enchanted" && /* @__PURE__ */ React.createElement("div", { className: "vm-layer", "aria-hidden": "true" }, SPARKLES.map(([x, y], i) => /* @__PURE__ */ React.createElement(
      "span",
      {
        key: i,
        className: "vm-sparkle",
        style: {
          left: `${x}%`,
          top: `${y}%`,
          animationDelay: `${i * 0.6 % 2.4}s`
        }
      }
    ))),
    showStatus && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "vm-status", role: "status", "aria-live": "polite" }, !locked && /* @__PURE__ */ React.createElement("span", { className: "vm-status-dot", "aria-hidden": "true" }), status), isTech && readout && /* @__PURE__ */ React.createElement("div", { className: "vm-readout", "aria-hidden": "true" }, readout.map((line, i) => /* @__PURE__ */ React.createElement("div", { key: i }, line)))),
    children,
    locked && /* @__PURE__ */ React.createElement("div", { className: "vm-locked-banner", "aria-hidden": "true" }, spec.locked),
    /* @__PURE__ */ React.createElement("div", { className: "vm-hud" }, /* @__PURE__ */ React.createElement("p", { className: "vm-hint" }, hint), progress !== void 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "vm-progress",
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": "Match progress"
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "vm-progress-fill",
          style: { width: `${progress}%` }
        }
      )
    )),
    after
  );
}

export {
  classes,
  ScannerFrame
};
//# sourceMappingURL=chunk-HXABEUTY.mjs.map